module.exports = __webpack_public_path__ + "img/tertiary_11x4_z16.00075bdc.svg";